import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { useEffect, useMemo, useState } from "react";
import DailyPlanCalendar from "./DailyPlanCalendar";
import Error from "../../ErrorPages/Error";
import Select from "react-select";
import DebouncedInput from "../../Base/DebouncedInput";
import secureLocalStorage from "react-secure-storage";

const DailyPlan = () => {
    const departments = secureLocalStorage.getItem("department");
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [filter, setFilter] = useState({
        machine: "",
        department: "",
    });

    const handleAccordionClick = (machineId) => {
        setActiveAccordion((prev) => (prev === machineId ? null : machineId));
    };

    const { useFetch: useFetchMachinesHook } = useAPIQuery({
        key: "machines",
        endpoint: "/api/machine-list/",
    });

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data: genericData, isLoading: loadingGenericData } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { data, isLoading, isError, isFetching } = useFetchMachinesHook({
        params: {
            q: Object.entries(filter)
                .filter(([_, v]) => v !== "")
                .map(([_, v]) => v)
                .join(","),
            c: Object.entries(filter)
                .filter(([_, v]) => v !== "")
                .map(([k]) => k)
                .join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const machines = useMemo(() => {
        if (data) {
            return data.data;
        }
    }, [data]);
    if (isLoading) return <div>Loading...</div>;
    if (isError || !data) return <Error />;

    return (
        <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
                <div className="nk-block-head-content d-flex">
                    <h3 className="nk-block-title page-title">Daily Plan</h3>
                </div>
                {isFetching && (
                    <div
                        className="spinner-border text-primary ms-2"
                        role="status"
                    >
                        <span className="sr-only"></span>
                    </div>
                )}
            </div>
            <div className="card mt-3">
                <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-sm-4 m-1">
                        <div className="form-control-wrap">
                            <DebouncedInput
                                type="text"
                                className="form-control"
                                placeholder="Search machine by name"
                                value={filter.machine}
                                onChange={(val) =>
                                    setFilter((prev) => ({
                                        ...prev,
                                        machine: val,
                                    }))
                                }
                            />
                        </div>
                    </div>
                    <div className="col-sm-4 m-1">
                        <div className="form-control-wrap">
                            <Select
                                options={
                                    departments?.map((dept) => ({
                                        value: dept?.department__department_name,
                                        label: dept?.department__department_name,
                                    })) ?? []
                                }
                                onChange={(val) =>
                                    setFilter((prev) => ({
                                        ...prev,
                                        department: val?.value || "",
                                    }))
                                }
                                placeholder="Filter by department"
                                isClearable
                            />
                        </div>
                    </div>
                </div>
                <div id="accordion" className="accordion">
                    {machines?.map((machine, index) => (
                        <div key={index} className="accordion-item">
                            <a
                                href="#"
                                className="accordion-head"
                                data-bs-toggle="collapse"
                                data-bs-target={`#machine-${machine?.id}`}
                                // Review - Vaishnavi - 22/01/25 - If machine id is missing the condition should handle here
                                onClick={() =>
                                    handleAccordionClick(machine?.id)
                                }
                            >
                                <div className="d-flex align-items-center">
                                    <h6 className="title mb-0">
                                        {machine?.machine_name}
                                    </h6>
                                    <span className="badge bg-info my-1 ms-auto me-5">
                                        {machine?.department_name}
                                    </span>
                                </div>
                                <span className="accordion-icon"></span>
                            </a>
                            <div
                                className="accordion-body collapse"
                                id={`machine-${machine?.id}`}
                                data-bs-parent="#accordion"
                            >
                                <div
                                    className="accordion-inner"
                                    style={{ height: "700px" }}
                                >
                                    {activeAccordion === machine?.id && (
                                        <DailyPlanCalendar
                                            machine_id={machine?.id}
                                            wip={machine?.wip}
                                            activeAccordion={activeAccordion}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DailyPlan;
